import Vue from "vue";
import Router from "vue-router";
import Index from "./layouts/default.vue";
import backOffice from "./layouts/LayoutBack.vue";
import { store } from "./store/store";
import indexWeserve from "@/pages/index.vue";
import NotFound from "@/pages/404.vue";
import { axiosPath } from "./axios-path.js";

function loadFirst(component) {
  return () => import(`@/pages/front-web/${component}.vue`);
}

function storePreview(component) {
  return () => import(`@/pages/front-web/${component}.vue`);
}

function loadMessengerBack(component) {
  return () => import(`@/pages/back-office/Messenger/${component}.vue`);
}

function loadFrontWeb(component) {
  return () => import(`@/pages/front-web/${component}.vue`);
}

function loadBackOffice(component) {
  return () => import(`@/pages/back-office/${component}.vue`);
}

function loadOrderBackOffice(component) {
  return () => import(`@/pages/back-office/OrderDashboard/${component}.vue`);
}

function loadWeserveBackOffice(component) {
  return () => import(`@/pages/back-office/Food/${component}.vue`);
}

function loadWeserveBackOfficeSetApp(component) {
  return () => import(`@/pages/back-office/SetApp/${component}.vue`);
}

function loadWeserveBackOfficePromotion(component) {
  return () => import(`@/pages/back-office/Food/Promotion/${component}.vue`);
}

function loadWeserveBackOfficeTrasfer(component) {
  return () => import(`@/pages/back-office/Food/Transfer/${component}.vue`);
}

function loadWeserveBackOfficeFree(component) {
  return () => import(`@/pages/back-office/Food/FreeSetting/${component}.vue`);
}

function loadPosBackOffice(component) {
  return () => import(`@/pages/back-office/POS/${component}.vue`);
}

function loadRiderBackOffice(component) {
  return () => import(`@/pages/back-office/Rider/${component}.vue`);
}

function loadDashboardReportBackOffice(component) {
  return () => import(`@/pages/back-office/Report/Dashboard/${component}.vue`);
}

Vue.use(Router);
const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/order_receipt/:province/order/:orderid",
      name: "OrderDetailReceipt",
      component: loadOrderBackOffice("OrderReceipt"),
    },
    {
      path: "/store_preview/:province/:store_id/",
      name: "storereview",
      component: storePreview("StorePreview"),
    },
    {
      path: "/blog/:blog_id",
      name: "blogview",
      component: () => import(`@/pages/front-web/Blog.vue`),
    },
    {
      path: "/document",
      name: "documentUpload",
      component: () => import(`@/pages/front-web/UploadDocument.vue`),
    },
    {
      path: "/downloadapp",
      name: "downloadapp",
      component: loadFirst("LoadApp"),
      beforeEnter: (to, from, next) => {
        var isMobile = {
          Android: function () {
            return navigator.userAgent.match(/Android/i);
          },
          BlackBerry: function () {
            return navigator.userAgent.match(/BlackBerry/i);
          },
          iOS: function () {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
          },
          Opera: function () {
            return navigator.userAgent.match(/Opera Mini/i);
          },
          Windows: function () {
            return navigator.userAgent.match(/IEMobile/i);
          },
          any: function () {
            return (
              isMobile.Android() ||
              isMobile.BlackBerry() ||
              isMobile.iOS() ||
              isMobile.Opera() ||
              isMobile.Windows()
            );
          },
        };
        if (isMobile.Android()) {
          location.replace(
            "https://play.google.com/store/apps/details?id=v4.weserve.application"
          );
        } else if (isMobile.iOS()) {
          location.replace(
            "https://apps.apple.com/th/app/weserve/id1464895492?l=th#?platform=iphone"
          );
        } else {
          next("/");
        }
      },
    },
    {
      path: "/",
      name: "langingweserve",
      component: loadFirst("LandingWeserve"),
    },
    {
      path: "/:selectprovince/download_weserve_app",
      name: "apppage",
      component: loadFirst("LoadApp"),
    },
    {
      path: "/weserve_admin_login",
      component: Index,
      children: [
        {
          path: "",
          name: "indexWeserve",
          component: indexWeserve,
          beforeEnter: (to, from, next) => {
            if (!store.state.acctoken) {
              next();
            } else {
              next("/weserve_admin_login/select");
            }
          },
        },
        {
          path: "/weserve_admin_login/select",
          component: backOffice,
          props: true,
          beforeEnter: (to, from, next) => {
            //permisstion algo
            if (Object.keys(store.state.permission).length == 0) {
              store.dispatch("logout");
            } else {
              if (router.history.pending.params.province) {
                if (
                  store.state.permission.province &&
                  store.state.permission.province.length > 0 &&
                  !store.state.permission.province.includes("all")
                ) {
                  if (
                    !store.state.permission.province.includes(
                      router.history.pending.params.province
                    )
                  ) {
                    if (store.state.permission.province.length > 0) {
                      router.history.pending.params.province =
                        store.state.permission.province[0];
                    } else {
                      store.dispatch("logout");
                    }
                  }
                }
              }
              //permisstion algo
              store.dispatch("fetchProvinceBack/getData").then((res) => {
                if (
                  res === false ||
                  store.state.acctoken == null ||
                  store.state.role == "customer" ||
                  store.state.role == "store"
                ) {
                  store.dispatch("logout");
                } else {
                  if (
                    router.history.pending.params.province &&
                    router.history.pending.params.province != "-"
                  ) {
                    let provinceFind = res.find((val) => {
                      let province_set = "";
                      let province_split = val.province_name_en.split(" ");
                      for (let val2 of province_split) {
                        province_set += val2;
                      }
                      return (
                        province_set.toString().toLowerCase() ==
                        router.history.pending.params.province
                      );
                    });
                    if (provinceFind) {
                      let domain =
                        provinceFind.province_domain +
                        `/api/v${process.env.VUE_APP_BACKEND_API_VERSION}/` +
                        router.history.pending.params.province;
                      axiosPath.defaults.baseURL = domain;
                    }
                    store
                      .dispatch(
                        "getAPIList",
                        router.history.pending.params.province
                      )
                      .then(() => next());
                  } else {
                    next();
                  }
                }
              });
            }
          },
          children: [
            {
              path: "",
              name: "Home",
              component: loadBackOffice("HomePage"),
              props: true,
            },
            {
              path: "/weserve_admin_login/:province/rolemanage",
              name: "RoleManage",
              component: loadBackOffice("RoleManage"),
              props: true,
            },
            {
              path: "/weserve_admin_login/:province/:roleid/roleinformation",
              name: "RoleInformation",
              component: loadBackOffice("RoleInformation"),
              props: true,
            },
            {
              path: "/weserve_admin_login/:province/appmaintenance",
              name: "appmaintenance",
              component: loadBackOffice("AppMaintenance"),
              props: true,
            },
            {
              path: "/weserve_admin_login/select/:province",
              name: "selectDashboard",
              component: loadBackOffice("SelectDashboard"),
              props: true,
            },
            {
              path: "/weserve_admin_login/control/:province/",
              name: "selectService",
              component: loadBackOffice("SelectService"),
              props: true,
            },
            {
              path: "/weserve_admin_login/:province/usermanage",
              name: "usermanage",
              component: loadBackOffice("UserManage"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.main_menu.manage_staff) {
                  next("/404");
                } else {
                  next();
                }
              },
            },
            {
              path: "/weserve_admin_login/:province/manager-manage",
              component: () => import("@/layouts/default.vue"),
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.main_menu.manager_manage) {
                  next("/404");
                } else {
                  next();
                }
              },
              children: [
                {
                  path: "",
                  name: "managerManage",
                  component: () =>
                    import("@/pages/back-office/ManagerUserManage/index.vue"),
                },
                {
                  path:
                    "transaction/:user_partner_id/:user_partner_first_name/:user_partner_last_name",
                  name: "transactionListmanager",
                  component: () =>
                    import("@/pages/back-office/ManagerUserManage/Transaction.vue"),
                },
                {
                  path:
                    "transaction/:user_partner_id/:user_partner_first_name/:transaction_partner_id/:transaction_partner_type",
                  name: "transactionByIDManager",
                  component: () =>
                    import("@/pages/back-office/ManagerUserManage/Transactionbill.vue"),
                },
                {
                  path:
                    "transaction/:user_partner_id/:user_partner_first_name/:transaction_partner_id/:transaction_partner_type/withdraw",
                  name: "transactionWithdraw",
                  component: () =>
                    import("@/pages/back-office/ManagerUserManage/transactionWithdrawView.vue"),
                },
                {
                  path: ":manager_id/:manager_name/:province_id/invoice",
                  component: () => import("@/layouts/default.vue"),
                  children: [
                    {
                      path: "",
                      name: "managerInvoice",
                      component: () =>
                        import("@/pages/back-office/ManagerUserManage/ManagerInvoice/index.vue"),
                    },
                    {
                      path: "view/:invoice_id",
                      name: "ManagerInvoiceByID",
                      component: () =>
                        import("@/pages/back-office/ManagerUserManage/ManagerInvoice/_id.vue"),
                    },
                    {
                      path: "edit",
                      component: () => import("@/layouts/default.vue"),
                      children: [
                        {
                          path: ":invoice_id",
                          name: "EditmanagerInvoice",
                          component: () =>
                            import("@/pages/back-office/ManagerUserManage/ManagerInvoice/edit/_id.vue"),
                        },
                      ],
                    },
                    {
                      path: "create",
                      name: "CreateManagerInvoice",
                      component: () =>
                        import("@/pages/back-office/ManagerUserManage/ManagerInvoice/create/index.vue"),
                    },
                  ],
                },
              ],
            },
            {
              path: "/weserve_admin_login/:province/money",
              component: () => import("@/layouts/default.vue"),
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.main_menu.manager_manage) {
                  next("/404");
                } else {
                  next();
                }
              },
              children: [
                {
                  path: "",
                  name: "moneymanage",
                  component: () =>
                    import("@/pages/back-office/ManagerUserManage/moneymanage.vue"),
                },
              ],
            },
            {
              path: "/weserve_admin_login/:province/servicemanage",
              name: "servicemanage",
              component: loadBackOffice("ServiceManage/index"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.main_menu.service_manage) {
                  next("/404");
                } else {
                  next();
                }
              },
            },
            {
              path: "/weserve_admin_login/:province/CommissionArea",
              component: () => import("@/layouts/default.vue"),
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.main_menu.manager_manage) {
                  next("/404");
                } else {
                  next();
                }
              },
              children: [
                {
                  path: "",
                  name: "CommissionArea",
                  component: () =>
                    import("@/pages/back-office/ManagerUserManage/Commission Area.vue"),
                },
                {
                  path: ":commission_id",
                  component: () => import("@/layouts/default.vue"),
                  children: [
                    {
                      path: "",
                      name: "managerCommission",
                      component: () =>
                        import("@/pages/back-office/ManagerUserManage/CommissionArea/CommissionDetail.vue"),
                    },
                  ],
                },
              ],
            },
            {
              path: "/weserve_admin_login/:province/BankList",
              component: () => import("@/layouts/default.vue"),
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.main_menu.manager_manage) {
                  next("/404");
                } else {
                  next();
                }
              },
              children: [
                {
                  path: "",
                  name: "bankList",
                  component: () =>
                    import("@/pages/back-office/ManagerUserManage/banklist.vue"),
                },
              ],
            },
            {
              path: "/weserve_admin_login/:province/Bankapprove",
              component: () => import("@/layouts/default.vue"),
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.main_menu.manager_manage) {
                  next("/404");
                } else {
                  next();
                }
              },
              children: [
                {
                  path: "",
                  name: "bankApprove",
                  component: () =>
                    import("@/pages/back-office/ManagerUserManage/bankApprove.vue"),
                },
              ],
            },
            {
              path: "/weserve_admin_login/:province/Withdraw",
              component: () => import("@/layouts/default.vue"),
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.main_menu.manager_manage) {
                  next("/404");
                } else {
                  next();
                }
              },
              children: [
                {
                  path: "",
                  name: "Withdraw",
                  component: () =>
                    import("@/pages/back-office/ManagerUserManage/commissionWithdraw.vue"),
                },
              ],
            },
            {
              path: "/weserve_admin_login/:province/pointmanage",
              name: "pointmanage",
              component: loadBackOffice("PointManage/index"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.main_menu.point_manage) {
                  next("/404");
                } else {
                  next();
                }
              },
            },
            {
              path: "/weserve_admin_login/:province/tierbenefitsmanage",
              name: "tierbenefitsmanage",
              component: loadBackOffice("TierBenefitsManage/index"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.main_menu.tier_benefits_manage) {
                  next("/404");
                } else {
                  next();
                }
              },
            },
            {
              path: "/weserve_admin_login/:province/customermanage",
              name: "customermanage",
              component: loadBackOffice("CustomerManage"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.main_menu.customer_manage) {
                  next("/404");
                } else {
                  next();
                }
              },
            },
            {
              path: "/weserve_admin_login/:province/set_maintenance",
              name: "setmaintenancenage",
              component: loadBackOffice("SetAppMaintenance"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.main_menu.app_maintance) {
                  next("/404");
                } else {
                  next();
                }
              },
            },
            {
              path: "/weserve_admin_login/:province/find_user_otp",
              name: "find_user_otp",
              component: loadBackOffice("FindUserOTP"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.main_menu.find_user_otp) {
                  next("/404");
                } else {
                  next();
                }
              },
            },
            {
              path: "/weserve_admin_login/:province/appnotification",
              name: "appnotification",
              component: loadBackOffice("SetAppNotification"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.main_menu.app_notificaition) {
                  next("/404");
                } else {
                  next();
                }
              },
            },
            {
              path: "/weserve_admin_login/:province/appcampaignreward",
              name: "appcampaignreward",
              component: () => import("@/pages/back-office/CampaignReward.vue"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.main_menu.app_campaign_reward) {
                  next("/404");
                } else {
                  next();
                }
              },
            },
            {
              path: "/weserve_admin_login/:province/transfer-token-queue",
              name: "TransferTokenQueue",
              component: () =>
                import("@/pages/back-office/TransferTokenQueue.vue"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.main_menu.transfer_token_queue) {
                  next("/404");
                } else {
                  next();
                }
              },
            },
            {
              path: "/weserve_admin_login/:province/campaign-crypto",
              name: "campaigncrypto",
              component: () => import("@/pages/back-office/CampaignCrypto.vue"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.main_menu.campaign_crypto) {
                  next("/404");
                } else {
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/setapp/setpromotionbanner",
              name: "setpromotionbanner",
              component: loadWeserveBackOfficeSetApp(
                "SetPromotionBanner/index"
              ),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  Object.keys(store.state.permission.app_setting).length == 0
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "setapp";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/setapp/setoutofservicearea",
              name: "setoutofservicearea",
              component: () =>
                import("@/pages/back-office/SetApp/OutOfServiceArea.vue"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  Object.keys(store.state.permission.app_setting).length == 0
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "setapp";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/setapp/paymentmethod",
              name: "paymentmethod",
              component: () =>
                import("@/pages/back-office/SetApp/PaymentMethod.vue"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  Object.keys(store.state.permission.app_setting).length == 0
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "setapp";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path: "/weserve_admin_login/control/:province/setapp/setapp_zone",
              name: "setappzone",
              component: loadWeserveBackOfficeSetApp("SetAppZone/index"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  Object.keys(store.state.permission.app_setting).length == 0
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "setapp";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/setapp/setapp_store",
              name: "setappstore",
              component: loadWeserveBackOfficeSetApp("SetAppStore/index"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  Object.keys(store.state.permission.app_setting).length == 0
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "setapp";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/setapp/setapp_storetype",
              name: "setappstoretype",
              component: loadWeserveBackOfficeSetApp("SetAppStoreType/index"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  Object.keys(store.state.permission.app_setting).length == 0
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "setapp";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/setapp/setapp_subdistrict",
              name: "setappsubdistrict",
              component: loadWeserveBackOfficeSetApp("SetAppSubDistrict/index"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  Object.keys(store.state.permission.app_setting).length == 0
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "setapp";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/setapp/setapp_popup",
              name: "setapppopup",
              component: loadWeserveBackOfficeSetApp("SetAppPopup/index"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  Object.keys(store.state.permission.app_setting).length == 0
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "setapp";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/storeandproduct/storemanage",
              name: "storemanage",
              component: loadPosBackOffice("StoreManage"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.store_and_product.store_list) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "storeandproduct";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/storeandproduct/orderstorereview",
              name: "orderstorereview",
              component: loadPosBackOffice("OrderStoreReview"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.store_and_product.order_store_review
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "storeandproduct";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/storeandproduct/storeservicelist",
              name: "storeservicelist",
              component: loadPosBackOffice("StoreService"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.store_and_product.store_list) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "storeandproduct";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/storeandproduct/storetypelist",
              name: "storetypelist",
              component: loadPosBackOffice("StoreType"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.store_and_product.store_list) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "storeandproduct";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/storeandproduct/store/:store_id/storeinfo",
              name: "storeinfo",
              component: loadPosBackOffice("StoreInfo"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.store_and_product.store_list) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "storeandproduct";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/storeandproduct/store/:store_id/store_user",
              name: "store_user",
              component: loadPosBackOffice("StoreUser"),
              props: true,
              beforeEnter: (to, from, next) => {
                store.state.backOffice.service = "storeandproduct";
                store.state.backOffice.province =
                  router.history.pending.params.province;
                next();
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/storeandproduct/store/:store_id/product/:isEdit/id/:productid",
              name: "storeproductform",
              component: loadPosBackOffice("ProductForm"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.store_and_product.product_list) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "storeandproduct";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/storeandproduct/store/:store_id/product",
              name: "storeproductlist",
              component: loadPosBackOffice("InStoreProductList"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.store_and_product.product_list) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "storeandproduct";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/storeandproduct/store/:store_id/option",
              name: "storeoptionlist",
              component: loadPosBackOffice("InStoreOptionList"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.store_and_product.product_list) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "storeandproduct";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/:province/mainmerchant/documentapprove",
              name: "documentapprove",
              component: () =>
                import("@/pages/back-office/Merchant/DocumentApprove/index.vue"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.main_menu.merchant_manage ||
                  !store.state.permission.main_menu.merchant_manage
                    .approve_list ||
                  !store.state.permission.main_menu.merchant_manage.approve_list
                    .document_approve
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "mainmerchant";
                  if (router.history.pending.params.province != "-") {
                    store.state.backOffice.province =
                      router.history.pending.params.province;
                  }
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/:province/mainmerchant/userlogapproval",
              name: "userlogapproval",
              component: () =>
                import("@/pages/back-office/Merchant/UserLogApproval/index.vue"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.main_menu.merchant_manage ||
                  !store.state.permission.main_menu.merchant_manage
                    .approve_list ||
                  !store.state.permission.main_menu.merchant_manage.approve_list
                    .approve_log
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "mainmerchant";
                  if (router.history.pending.params.province != "-") {
                    store.state.backOffice.province =
                      router.history.pending.params.province;
                  }
                  next();
                }
              },
            },
            {
              path: "/weserve_admin_login/:province/mainmerchant/event-action",
              name: "actionEvent",
              component: () =>
                import("@/pages/back-office/Merchant/ActionsEventLog.vue"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.main_menu.merchant_manage ||
                  !store.state.permission.main_menu.merchant_manage
                    .approve_list ||
                  !store.state.permission.main_menu.merchant_manage.approve_list
                    .event_log
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "mainmerchant";
                  if (router.history.pending.params.province != "-") {
                    store.state.backOffice.province =
                      router.history.pending.params.province;
                  }
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/:province/mainmerchant/storeregistrantion",
              name: "storeregistrantion",
              component: () =>
                import("@/pages/back-office/Merchant/StoreRegistration/index.vue"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.main_menu.merchant_manage ||
                  !store.state.permission.main_menu.merchant_manage
                    .approve_list ||
                  !store.state.permission.main_menu.merchant_manage.approve_list
                    .store_status
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "mainmerchant";
                  if (router.history.pending.params.province != "-") {
                    store.state.backOffice.province =
                      router.history.pending.params.province;
                  }
                  next();
                }
              },
            },

            {
              path:
                "/weserve_admin_login/:province/mainmerchant/editstoreapprove",
              name: "storeapprove",
              component: loadPosBackOffice("EditStoreApprove"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.main_menu.merchant_manage ||
                  !store.state.permission.main_menu.merchant_manage
                    .approve_list ||
                  !store.state.permission.main_menu.merchant_manage.approve_list
                    .store_edit_approve
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "mainmerchant";
                  if (router.history.pending.params.province != "-") {
                    store.state.backOffice.province =
                      router.history.pending.params.province;
                  }
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/:province/mainmerchant/newsnotification",
              name: "newsnotification",
              component: () =>
                import("@/pages/back-office/Merchant/MerchantNews.vue"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.main_menu.merchant_manage ||
                  !store.state.permission.main_menu.merchant_manage
                    .notification ||
                  !store.state.permission.main_menu.merchant_manage.notification
                    .merchant_news
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "mainmerchant";
                  if (router.history.pending.params.province != "-") {
                    store.state.backOffice.province =
                      router.history.pending.params.province;
                  }
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/:province/mainmerchant/bannersnotification",
              name: "bannersnotification",
              component: () =>
                import("@/pages/back-office/Merchant/MerchantBanners.vue"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.main_menu.merchant_manage ||
                  !store.state.permission.main_menu.merchant_manage
                    .notification ||
                  !store.state.permission.main_menu.merchant_manage.notification
                    .merchant_news
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "mainmerchant";
                  if (router.history.pending.params.province != "-") {
                    store.state.backOffice.province =
                      router.history.pending.params.province;
                  }
                  next();
                }
              },
            },
            {
              path: "/weserve_admin_login/:province/maindinein",
              redirect:
                "/weserve_admin_login/:province/maindinein/order/new-order",
              component: () =>
                import("@/pages/back-office/DineInStore/index.vue"),
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.main_menu.dine_in_management) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "maindinein";
                  if (router.history.pending.params.province != "-") {
                    store.state.backOffice.province =
                      router.history.pending.params.province;
                  }
                  next();
                }
              },
              children: [
                {
                  path: "storemanage",
                  name: "storedineinmanage",
                  component: () =>
                    import("@/pages/back-office/DineInStore/StoreManagement/DineInStoreManagement.vue"),
                  props: true,
                  beforeEnter: (to, from, next) => {
                    if (
                      !store.state.permission.main_menu.dine_in_management ||
                      !store.state.permission.main_menu.dine_in_management
                        .manage_list ||
                      !store.state.permission.main_menu.dine_in_management
                        .manage_list.store_manage
                    ) {
                      next("/404");
                    } else {
                      store.state.backOffice.service = "maindinein";
                      if (router.history.pending.params.province != "-") {
                        store.state.backOffice.province =
                          router.history.pending.params.province;
                      }
                      next();
                    }
                  },
                },
                {
                  path: "storemanage/:store_id/:store_name/productlist",
                  name: "productdineinmanage",
                  component: () =>
                    import("@/pages/back-office/DineInStore/ProductManagement/DineinProductMangement.vue"),
                  props: true,
                  beforeEnter: (to, from, next) => {
                    if (
                      !store.state.permission.main_menu.dine_in_management ||
                      !store.state.permission.main_menu.dine_in_management
                        .manage_list ||
                      !store.state.permission.main_menu.dine_in_management
                        .manage_list.store_manage
                    ) {
                      next("/404");
                    } else {
                      store.state.backOffice.service = "maindinein";
                      if (router.history.pending.params.province != "-") {
                        store.state.backOffice.province =
                          router.history.pending.params.province;
                      }
                      next();
                    }
                  },
                },
                {
                  path: "storemanage/:store_id/:store_name/special-close",
                  name: "storeSpecialClose",
                  component: () =>
                    import("@/pages/back-office/DineInStore/SpecialClose/DineInSpecialClose.vue"),
                  props: true,
                  beforeEnter: (to, from, next) => {
                    if (
                      !store.state.permission.main_menu.dine_in_management ||
                      !store.state.permission.main_menu.dine_in_management
                        .manage_list ||
                      !store.state.permission.main_menu.dine_in_management
                        .manage_list.store_manage
                    ) {
                      next("/404");
                    } else {
                      store.state.backOffice.service = "maindinein";
                      if (router.history.pending.params.province != "-") {
                        store.state.backOffice.province =
                          router.history.pending.params.province;
                      }
                      next();
                    }
                  },
                },
                {
                  path: "createstore",
                  name: "createstore",
                  component: () =>
                    import("@/pages/back-office/DineInStore/CreateStore/index.vue"),
                  props: true,
                  beforeEnter: (to, from, next) => {
                    if (
                      !store.state.permission.main_menu.dine_in_management ||
                      !store.state.permission.main_menu.dine_in_management
                        .manage_list ||
                      !store.state.permission.main_menu.dine_in_management
                        .create_list.create_store
                    ) {
                      next("/404");
                    } else {
                      store.state.backOffice.service = "maindinein";
                      if (router.history.pending.params.province != "-") {
                        store.state.backOffice.province =
                          router.history.pending.params.province;
                      }
                      next();
                    }
                  },
                },
                {
                  path: "createstoretype",
                  name: "createstoretype",
                  component: () =>
                    import("@/pages/back-office/DineInStore/StoreType/CreateStoreType.vue"),
                  props: true,
                  beforeEnter: (to, from, next) => {
                    if (
                      !store.state.permission.main_menu.dine_in_management ||
                      !store.state.permission.main_menu.dine_in_management
                        .manage_list ||
                      !store.state.permission.main_menu.dine_in_management
                        .create_list.create_store_type
                    ) {
                      next("/404");
                    } else {
                      store.state.backOffice.service = "maindinein";
                      if (router.history.pending.params.province != "-") {
                        store.state.backOffice.province =
                          router.history.pending.params.province;
                      }
                      next();
                    }
                  },
                },
                {
                  path: "storetypemanage",
                  name: "storetypemanage",
                  component: () =>
                    import("@/pages/back-office/DineInStore/StoreType/DineInStoreTypeManagement.vue"),
                  props: true,
                  beforeEnter: (to, from, next) => {
                    if (
                      !store.state.permission.main_menu.dine_in_management ||
                      !store.state.permission.main_menu.dine_in_management
                        .manage_list ||
                      !store.state.permission.main_menu.dine_in_management
                        .manage_list.store_type_manage
                    ) {
                      next("/404");
                    } else {
                      store.state.backOffice.service = "maindinein";
                      if (router.history.pending.params.province != "-") {
                        store.state.backOffice.province =
                          router.history.pending.params.province;
                      }
                      next();
                    }
                  },
                },
                {
                  path: "/weserve_admin_login/:province/maindinein/order",
                  redirect:
                    "/weserve_admin_login/:province/maindinein/order/new-order",
                  component: () =>
                    import("@/pages/back-office/DineInStore/index.vue"),
                  beforeEnter: (to, from, next) => {
                    if (!store.state.permission.main_menu.dine_in_management) {
                      next("/404");
                    } else {
                      store.state.backOffice.service = "maindinein";
                      if (router.history.pending.params.province != "-") {
                        store.state.backOffice.province =
                          router.history.pending.params.province;
                      }
                      next();
                    }
                  },
                  children: [
                    {
                      path: "new-order",
                      name: "dineinOrderNewOrder",
                      component: () =>
                        import("@/pages/back-office/OrderDineIn/NewOrder.vue"),
                      props: true,
                      beforeEnter: (to, from, next) => {
                        if (
                          !store.state.permission.main_menu
                            .dine_in_management ||
                          !store.state.permission.main_menu.dine_in_management
                            .order_list ||
                          !store.state.permission.main_menu.dine_in_management
                            .order_list.order_new_order
                        ) {
                          next("/weserve_admin_login/-/maindinein/storemanage");
                        } else {
                          store.state.backOffice.service = "maindinein";
                          if (router.history.pending.params.province != "-") {
                            store.state.backOffice.province =
                              router.history.pending.params.province;
                          }
                          next();
                        }
                      },
                    },
                    {
                      path: "new-order/:order_id",
                      name: "dineinOrderDetailNewOrder",
                      component: () =>
                        import("@/pages/back-office/OrderDineIn/OrderDetail.vue"),
                      props: true,
                      beforeEnter: (to, from, next) => {
                        if (
                          !store.state.permission.main_menu
                            .dine_in_management ||
                          !store.state.permission.main_menu.dine_in_management
                            .order_list ||
                          !store.state.permission.main_menu.dine_in_management
                            .order_list.order_detail
                        ) {
                          next("/404");
                        } else {
                          store.state.backOffice.service = "maindinein";
                          if (router.history.pending.params.province != "-") {
                            store.state.backOffice.province =
                              router.history.pending.params.province;
                          }
                          next();
                        }
                      },
                    },
                    {
                      path: "on-process",
                      name: "dineinOrderOnProcess",
                      component: () =>
                        import("@/pages/back-office/OrderDineIn/OnProcess.vue"),
                      props: true,
                      beforeEnter: (to, from, next) => {
                        if (
                          !store.state.permission.main_menu
                            .dine_in_management ||
                          !store.state.permission.main_menu.dine_in_management
                            .order_list ||
                          !store.state.permission.main_menu.dine_in_management
                            .order_list.order_on_process
                        ) {
                          next("/weserve_admin_login/-/maindinein/storemanage");
                        } else {
                          store.state.backOffice.service = "maindinein";
                          if (router.history.pending.params.province != "-") {
                            store.state.backOffice.province =
                              router.history.pending.params.province;
                          }
                          next();
                        }
                      },
                    },
                    {
                      path: "on-process/:order_id",
                      name: "dineinOrderDetailOnProcess",
                      component: () =>
                        import("@/pages/back-office/OrderDineIn/OrderDetail.vue"),
                      props: true,
                      beforeEnter: (to, from, next) => {
                        if (
                          !store.state.permission.main_menu
                            .dine_in_management ||
                          !store.state.permission.main_menu.dine_in_management
                            .order_list ||
                          !store.state.permission.main_menu.dine_in_management
                            .order_list.order_detail
                        ) {
                          next("/404");
                        } else {
                          store.state.backOffice.service = "maindinein";
                          if (router.history.pending.params.province != "-") {
                            store.state.backOffice.province =
                              router.history.pending.params.province;
                          }
                          next();
                        }
                      },
                    },
                    {
                      path: "complete",
                      name: "dineinOrderComplete",
                      component: () =>
                        import("@/pages/back-office/OrderDineIn/Complete.vue"),
                      props: true,
                      beforeEnter: (to, from, next) => {
                        if (
                          !store.state.permission.main_menu
                            .dine_in_management ||
                          !store.state.permission.main_menu.dine_in_management
                            .order_list ||
                          !store.state.permission.main_menu.dine_in_management
                            .order_list.order_complete
                        ) {
                          next("/404");
                        } else {
                          store.state.backOffice.service = "maindinein";
                          if (router.history.pending.params.province != "-") {
                            store.state.backOffice.province =
                              router.history.pending.params.province;
                          }
                          next();
                        }
                      },
                    },
                    {
                      path: "complete/:order_id",
                      name: "dineinOrderDetailComplete",
                      component: () =>
                        import("@/pages/back-office/OrderDineIn/OrderDetail.vue"),
                      props: true,
                      beforeEnter: (to, from, next) => {
                        if (
                          !store.state.permission.main_menu
                            .dine_in_management ||
                          !store.state.permission.main_menu.dine_in_management
                            .order_list ||
                          !store.state.permission.main_menu.dine_in_management
                            .order_list.order_detail
                        ) {
                          next("/404");
                        } else {
                          store.state.backOffice.service = "maindinein";
                          if (router.history.pending.params.province != "-") {
                            store.state.backOffice.province =
                              router.history.pending.params.province;
                          }
                          next();
                        }
                      },
                    },
                    {
                      path: "cancel",
                      name: "dineinOrderCancel",
                      component: () =>
                        import("@/pages/back-office/OrderDineIn/Cancel.vue"),
                      props: true,
                      beforeEnter: (to, from, next) => {
                        if (
                          !store.state.permission.main_menu
                            .dine_in_management ||
                          !store.state.permission.main_menu.dine_in_management
                            .order_list ||
                          !store.state.permission.main_menu.dine_in_management
                            .order_list.order_cancel
                        ) {
                          next("/404");
                        } else {
                          store.state.backOffice.service = "maindinein";
                          if (router.history.pending.params.province != "-") {
                            store.state.backOffice.province =
                              router.history.pending.params.province;
                          }
                          next();
                        }
                      },
                    },
                    {
                      path: "cancel/:order_id",
                      name: "dineinOrderDetailCancel",
                      component: () =>
                        import("@/pages/back-office/OrderDineIn/OrderDetail.vue"),
                      props: true,
                      beforeEnter: (to, from, next) => {
                        if (
                          !store.state.permission.main_menu
                            .dine_in_management ||
                          !store.state.permission.main_menu.dine_in_management
                            .order_list ||
                          !store.state.permission.main_menu.dine_in_management
                            .order_list.order_detail
                        ) {
                          next("/404");
                        } else {
                          store.state.backOffice.service = "maindinein";
                          if (router.history.pending.params.province != "-") {
                            store.state.backOffice.province =
                              router.history.pending.params.province;
                          }
                          next();
                        }
                      },
                    },
                  ],
                },
                {
                  path: "store-category-management",
                  name: "StoreCategoryManagement",
                  component: () =>
                    import("@/pages/back-office/DineInStore/DineInStoreCategoryManagement.vue"),
                  props: true,
                  beforeEnter: (to, from, next) => {
                    if (
                      !store.state.permission.main_menu.dine_in_management ||
                      !store.state.permission.main_menu.dine_in_management
                        .manage_list ||
                      !store.state.permission.main_menu.dine_in_management
                        .manage_list.store_category_manage
                    ) {
                      next("/404");
                    } else {
                      store.state.backOffice.service = "maindinein";
                      if (router.history.pending.params.province != "-") {
                        store.state.backOffice.province =
                          router.history.pending.params.province;
                      }
                      next();
                    }
                  },
                },
                {
                  path: "store-review-management",
                  name: "StoreReviewManagement",
                  component: () =>
                    import("@/pages/back-office/DineInStore/StoreReview/DineInStoreReviewManagement.vue"),
                  props: true,
                  beforeEnter: (to, from, next) => {
                    if (
                      !store.state.permission.main_menu.dine_in_management ||
                      !store.state.permission.main_menu.dine_in_management
                        .review_list ||
                      !store.state.permission.main_menu.dine_in_management
                        .review_list.store_review_manage
                    ) {
                      next("/404");
                    } else {
                      store.state.backOffice.service = "maindinein";
                      if (router.history.pending.params.province != "-") {
                        store.state.backOffice.province =
                          router.history.pending.params.province;
                      }
                      next();
                    }
                  },
                },
                {
                  path: "dinein-review-benefit",
                  component: () => import("@/layouts/default.vue"),
                  beforeEnter: (to, from, next) => {
                    if (
                      !store.state.permission.main_menu.dine_in_management ||
                      !store.state.permission.main_menu.dine_in_management
                        .review_list ||
                      !store.state.permission.main_menu.dine_in_management
                        .review_list.review_benefit
                    ) {
                      next("/404");
                    } else {
                      store.state.backOffice.service = "maindinein";
                      if (router.history.pending.params.province != "-") {
                        store.state.backOffice.province =
                          router.history.pending.params.province;
                      }
                      next();
                    }
                  },
                  children: [
                    {
                      path: "",
                      name: "DineInReviewBenefit",
                      component: () =>
                        import("@/pages/back-office/DineInStore/StoreReview/DineInReviewBenefit.vue"),
                    },
                    {
                      path: ":campaign_review_id/logtable",
                      name: "ReviewBenefitLogTable",
                      component: () =>
                        import("@/pages/back-office/DineInStore/StoreReview/DineInReviewBenefitLog.vue"),
                    },
                  ]
                },
                {
                  path: "setting",
                  redirect:
                    "/weserve_admin_login/:province/maindinein/setting/district",
                  component: () => import("@/layouts/default.vue"),
                  beforeEnter: (to, from, next) => {
                    if (!store.state.permission.main_menu.dine_in_management) {
                      next("/404");
                    } else {
                      store.state.backOffice.service = "maindinein";
                      if (router.history.pending.params.province != "-") {
                        store.state.backOffice.province =
                          router.history.pending.params.province;
                      }
                      next();
                    }
                  },
                  children: [
                    {
                      path: "district",
                      name: "dineinDistrict",
                      component: () =>
                        import("@/pages/back-office/DineInSetting/DistrictSetting.vue"),
                      props: true,
                      beforeEnter: (to, from, next) => {
                        if (
                          !store.state.permission.main_menu
                            .dine_in_management ||
                          !store.state.permission.main_menu.dine_in_management
                            .order_list ||
                          !store.state.permission.main_menu.dine_in_management
                            .order_list.order_new_order
                        ) {
                          next("/weserve_admin_login/-/maindinein/storemanage");
                        } else {
                          store.state.backOffice.service = "maindinein";
                          if (router.history.pending.params.province != "-") {
                            store.state.backOffice.province =
                              router.history.pending.params.province;
                          }
                          next();
                        }
                      },
                    },
                  ],
                },
              ],
            },
            {
              path: "/weserve_admin_login/:province/reportdashboard/main",
              component: () =>
                import("@/pages/back-office/Report/MainDashboard.vue"),
              beforeEnter: (to, from, next) => {
                if (
                  "main" in store.state.permission.main_menu.report_dashboard
                ) {
                  store.state.backOffice.service = "report_dashboard";
                  if (router.history.pending.params.province != "-") {
                    store.state.backOffice.province =
                      router.history.pending.params.province;
                  }
                  next();
                } else {
                  next("/404");
                }
              },
              children: [
                {
                  path: "",
                  name: "mainDashboard",
                  component: () =>
                    import("@/pages/back-office/Report/MainDashboard/index.vue"),
                },
                {
                  path: "reward-report",
                  name: "rewardreport",
                  component: () =>
                    import("@/pages/back-office/Report/MainDashboard/RewardReport.vue"),
                  beforeEnter: (to, from, next) => {
                    if (
                      "report_reward" in
                      store.state.permission.main_menu.report_dashboard.main
                    ) {
                      store.state.backOffice.service = "report_dashboard";
                      if (router.history.pending.params.province != "-") {
                        store.state.backOffice.province =
                          router.history.pending.params.province;
                      }
                      next();
                    } else {
                      next("/404");
                    }
                  },
                },
                {
                  path: "packages-report",
                  name: "packagesReport",
                  component: () =>
                    import("@/pages/back-office/Report/MainDashboard/PackagesReport.vue"),
                  beforeEnter: (to, from, next) => {
                    if (
                      "packages_report" in
                      store.state.permission.main_menu.report_dashboard.main
                    ) {
                      store.state.backOffice.service = "report_dashboard";
                      if (router.history.pending.params.province != "-") {
                        store.state.backOffice.province =
                          router.history.pending.params.province;
                      }
                      next();
                    } else {
                      next("/404");
                    }
                  },
                },
                {
                  path: "connect-wallet-report",
                  name: "connectWalletReport",
                  component: () =>
                    import("@/pages/back-office/Report/MainDashboard/ConnectWalletReport.vue"),
                  beforeEnter: (to, from, next) => {
                    if (
                      "connect_wallet_report" in
                      store.state.permission.main_menu.report_dashboard.main
                    ) {
                      store.state.backOffice.service = "report_dashboard";
                      if (router.history.pending.params.province != "-") {
                        store.state.backOffice.province =
                          router.history.pending.params.province;
                      }
                      next();
                    } else {
                      next("/404");
                    }
                  },
                },
                {
                  path: "wellness-report",
                  name: "wellnessReport",
                  component: () =>
                    import("@/pages/back-office/Report/MainDashboard/WellnessReport.vue"),
                  beforeEnter: (to, from, next) => {
                    if (
                      "wellness_report" in
                      store.state.permission.main_menu.report_dashboard.main
                    ) {
                      store.state.backOffice.service = "report_dashboard";
                      if (router.history.pending.params.province != "-") {
                        store.state.backOffice.province =
                          router.history.pending.params.province;
                      }
                      next();
                    } else {
                      next("/404");
                    }
                  },
                },
                {
                  path: "dine-in-report",
                  name: "dineInReport",
                  component: () =>
                    import("@/pages/back-office/Report/MainDashboard/DineInReport.vue"),
                  beforeEnter: (to, from, next) => {
                    if (
                      "order_dineIn_report" in
                      store.state.permission.main_menu.report_dashboard.main
                    ) {
                      store.state.backOffice.service = "report_dashboard";
                      if (router.history.pending.params.province != "-") {
                        store.state.backOffice.province =
                          router.history.pending.params.province;
                      }
                      next();
                    } else {
                      next("/404");
                    }
                  },
                },
                {
                  path: "dine-in-report/:order_id",
                  name: "dineInReportById",
                  component: () =>
                    import("@/pages/back-office/Report/MainDashboard/DineInReportByID.vue"),
                  beforeEnter: (to, from, next) => {
                    if (
                      "order_dineIn_report" in
                      store.state.permission.main_menu.report_dashboard.main
                    ) {
                      store.state.backOffice.service = "report_dashboard";
                      if (router.history.pending.params.province != "-") {
                        store.state.backOffice.province =
                          router.history.pending.params.province;
                      }
                      next();
                    } else {
                      next("/404");
                    }
                  },
                },
                {
                  path: "dine-in-sale-store",
                  name: "dineInSaleStore",
                  component: () =>
                    import("@/pages/back-office/Report/MainDashboard/DineInsaleReport.vue"),
                  beforeEnter: (to, from, next) => {
                    if (
                      "order_dineIn_report" in
                      store.state.permission.main_menu.report_dashboard.main
                    ) {
                      store.state.backOffice.service = "report_dashboard";
                      if (router.history.pending.params.province != "-") {
                        store.state.backOffice.province =
                          router.history.pending.params.province;
                      }
                      next();
                    } else {
                      next("/404");
                    }
                  },
                },
              ],
            },
            {
              path: "/weserve_admin_login/:province/promotion-manage",
              name: "promotionlist",
              component: () =>
                import("@/pages/back-office/Promotion/PromotionList.vue"),
              beforeEnter: (to, from, next) => {
                if ("promotion_manage" in store.state.permission.main_menu) {
                  store.state.backOffice.service = "promotion_manage";
                  if (router.history.pending.params.province != "-") {
                    store.state.backOffice.province =
                      router.history.pending.params.province;
                  }
                  next();
                } else {
                  next("/404");
                }
              },
            },
            {
              path:
                "/weserve_admin_login/:province/promotion-manage/promotion-log/:promotion_id",
              name: "promotionLog",
              component: () =>
                import("@/pages/back-office/Promotion/PromotionLog.vue"),
              beforeEnter: (to, from, next) => {
                if ("promotion_manage" in store.state.permission.main_menu) {
                  store.state.backOffice.service = "promotion_manage";
                  if (router.history.pending.params.province != "-") {
                    store.state.backOffice.province =
                      router.history.pending.params.province;
                  }
                  next();
                } else {
                  next("/404");
                }
              },
            },
            {
              path:
                "/weserve_admin_login/:province/mainmerchant/contactstoreapprove",
              name: "contactstoreapprove",
              component: () =>
                import("@/pages/back-office/Merchant/ContactApprove/index.vue"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.main_menu.merchant_manage ||
                  !store.state.permission.main_menu.merchant_manage
                    .approve_list ||
                  !store.state.permission.main_menu.merchant_manage.approve_list
                    .contact_approve
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "mainmerchant";
                  if (router.history.pending.params.province != "-") {
                    store.state.backOffice.province =
                      router.history.pending.params.province;
                  }
                  next();
                }
              },
            },
            {
              path: "/weserve_admin_login/:province/mainmerchant/storeapprove",
              name: "merchantstoreapprove",
              component: () =>
                import("@/pages/back-office/Merchant/StoreApprove/index.vue"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.main_menu.merchant_manage ||
                  !store.state.permission.main_menu.merchant_manage
                    .approve_list ||
                  !store.state.permission.main_menu.merchant_manage.approve_list
                    .store_approve
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "mainmerchant";
                  if (router.history.pending.params.province != "-") {
                    store.state.backOffice.province =
                      router.history.pending.params.province;
                  }
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/:province/mainmerchant/store_user_manage",
              name: "store_user_manage",
              component: () =>
                import("@/pages/back-office/Merchant/StoreManageUser/StoreUserManagement.vue"),
              // props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.main_menu.merchant_manage ||
                  !store.state.permission.main_menu.merchant_manage
                    .dine_in_merchant ||
                  !store.state.permission.main_menu.merchant_manage
                    .dine_in_merchant.store_manage_user
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "mainmerchant";
                  if (router.history.pending.params.province != "-") {
                    store.state.backOffice.province =
                      router.history.pending.params.province;
                  }
                  next();
                }
              },
            },
            {
              path: "/weserve_admin_login/:province/mainmerchant/userlist",
              name: "merchantuserlist",
              component: () =>
                import("@/pages/back-office/Merchant/UserList.vue"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.main_menu.merchant_manage ||
                  !store.state.permission.main_menu.merchant_manage.user_list ||
                  !store.state.permission.main_menu.merchant_manage.user_list
                    .edit_view
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "mainmerchant";
                  if (router.history.pending.params.province != "-") {
                    store.state.backOffice.province =
                      router.history.pending.params.province;
                  }
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/storeandproduct/store/:store_id/producttype",
              name: "storeproductype",
              component: loadPosBackOffice("InStoreProductType"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.store_and_product.product_list) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "storeandproduct";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/storeandproduct/store/:store_id/:store_name/option_management",
              name: "option_management",
              component: loadPosBackOffice("OptionManagementList"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.store_and_product.product_list) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "storeandproduct";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/storeandproduct/productmanage",
              name: "productmanage",
              component: loadPosBackOffice("ProductManage"),
              props: true,
              beforeEnter: (to, from, next) => {
                store.state.backOffice.service = "storeandproduct";
                store.state.backOffice.province =
                  router.history.pending.params.province;
                next();
              },
            },
            {
              path: "/weserve_admin_login/control/:province/food/promotion",
              name: "promotion",
              component: loadWeserveBackOfficePromotion("index"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.food.promotion_list) {
                  next("/404");
                } else {
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  store.state.backOffice.service = "weserve";
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/food/campaigndistance", //KUY
              name: "CampaignDistance",
              component: () =>
                import("@/pages/back-office/CampaignDistance.vue"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.food.promotion_list) {
                  next("/404");
                } else {
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  store.state.backOffice.service = "weserve";
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/food/:promotionid/promotionlog",
              name: "promotionlog",
              component: loadWeserveBackOfficePromotion("PromotionLog"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.food.promotion_list) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "weserve";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/food/transfer/transferlist",
              name: "transferlist",
              component: loadWeserveBackOfficeTrasfer("TransferList/index"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.food.transfer_list) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "weserve";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/food/transfer/transfer_extra_time",
              name: "transfer_extra_time",
              component: loadWeserveBackOfficeTrasfer(
                "TransferExtraTime/index"
              ),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.food.transfer_list) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "weserve";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/food/transfer/transfer_extra_store",
              name: "transfer_extra_store",
              component: loadWeserveBackOfficeTrasfer(
                "TransferExtraStore/index"
              ),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.food.transfer_list) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "weserve";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/food/transfer/transfer_zone",
              name: "transfer_zone",
              component: loadWeserveBackOfficeTrasfer("TransferZone/index"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.food.transfer_list) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "weserve";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/food/transfer/transfer_sub_district",
              name: "transfer_sub_district",
              component: loadWeserveBackOfficeTrasfer(
                "TransferSubDistrict/index"
              ),
              props: true,
              beforeEnter: (to, from, next) => {
                store.state.backOffice.service = "weserve";
                store.state.backOffice.province =
                  router.history.pending.params.province;
                next();
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/food/free/set_price_round",
              name: "set_price_round",
              component: loadWeserveBackOfficeFree("SetPriceRound/index"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.food.set_free_price_round) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "weserve";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path: "/weserve_admin_login/control/:province/food/basedistance",
              name: "basedistance",
              component: () =>
                import("@/pages/back-office/Food/BaseDistance/index.vue"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.food.base_distance) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "weserve";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/food/customer-base-distance",
              name: "CustomerBaseDistance",
              component: () =>
                import("@/pages/back-office/Food/CustomerBaseDistance/index.vue"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.food.base_distance) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "weserve";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/food/rider-base-distance",
              name: "RiderBaseDistance",
              component: () =>
                import("@/pages/back-office/Food/RiderBaseDistance/index.vue"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.food.base_distance) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "weserve";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/food/addon-service",
              component: () => import("@/layouts/blankLayout.vue"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.food.food_add_on) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "weserve";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
              children: [
                {
                  path: "",
                  name: "AddOnFood",
                  component: () =>
                    import("@/pages/back-office/Food/AddonList/index.vue"),
                  props: true,
                  beforeEnter: (to, from, next) => {
                    if (!store.state.permission.food.food_add_on) {
                      next("/404");
                    } else {
                      store.state.backOffice.service = "weserve";
                      store.state.backOffice.province =
                        router.history.pending.params.province;
                      next();
                    }
                  },
                },
              ],
            },
            {
              path:
                "/weserve_admin_login/control/:province/food/minimum-price-food",
              component: () => import("@/layouts/blankLayout.vue"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.food.small_order_difference) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "weserve";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
              children: [
                {
                  path: "",
                  name: "SmallOrderDifference",
                  component: () =>
                    import("@/pages/back-office/Food/SmallOrderDifference/index.vue"),
                  props: true,
                  beforeEnter: (to, from, next) => {
                    if (!store.state.permission.food.small_order_difference) {
                      next("/404");
                    } else {
                      store.state.backOffice.service = "weserve";
                      store.state.backOffice.province =
                        router.history.pending.params.province;
                      next();
                    }
                  },
                },
                {
                  path: ":no/:small_order_difference_id",
                  name: "SmallOrderDifferenceById",
                  component: () =>
                    import("@/pages/back-office/Food/SmallOrderDifference/_id.vue"),
                  props: true,
                  beforeEnter: (to, from, next) => {
                    if (!store.state.permission.food.small_order_difference) {
                      next("/404");
                    } else {
                      store.state.backOffice.service = "weserve";
                      store.state.backOffice.province =
                        router.history.pending.params.province;
                      next();
                    }
                  },
                },]
            },
            {
              path: "/weserve_admin_login/control/:province/food/packagelist",
              name: "packagelist",
              component: loadWeserveBackOffice("PackageList/index"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.food.package_list) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "weserve";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/orderweserve/:province/orderlist/ordermade",
              name: "ordermade",
              component: loadOrderBackOffice("OrderMade"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (Object.keys(store.state.permission.order).length == 0) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "order";
                  store.state.fetchOrderListBack.order_status_id = 1;
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/orderweserve/:province/orderlist/cancel",
              name: "cancel",
              component: loadOrderBackOffice("Cancel"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (Object.keys(store.state.permission.order).length == 0) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "order";
                  store.state.fetchOrderListBack.order_status_id = 7;
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/orderweserve/:province/orderlist/completed",
              name: "completed",
              component: loadOrderBackOffice("Completed"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (Object.keys(store.state.permission.order).length == 0) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "order";
                  store.state.fetchOrderListBack.order_status_id = 6;
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/orderweserve/:province/orderlist/cooking",
              name: "cooking",
              component: loadOrderBackOffice("Cooking"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (Object.keys(store.state.permission.order).length == 0) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "order";
                  store.state.fetchOrderListBack.order_status_id = 3;
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/orderweserve/:province/orderlist/inqueue",
              name: "inqueue",
              component: loadOrderBackOffice("InQueue"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (Object.keys(store.state.permission.order).length == 0) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "order";
                  store.state.fetchOrderListBack.order_status_id = 2;
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/orderweserve/:province/orderlist/ontheway",
              name: "ontheway",
              component: loadOrderBackOffice("OnTheWay"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (Object.keys(store.state.permission.order).length == 0) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "order";
                  store.state.fetchOrderListBack.order_status_id = 5;
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/orderweserve/:province/orderlist/readytopick",
              name: "readytopick",
              component: loadOrderBackOffice("ReadyToPick"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (Object.keys(store.state.permission.order).length == 0) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "order";
                  store.state.fetchOrderListBack.order_status_id = 4;
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/orderweserve/:province/orderlist/preorder",
              name: "preorder",
              component: loadOrderBackOffice("Preorder"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  "order" in store.state.permission &&
                  Object.keys(store.state.permission.order).length > 0
                ) {
                  store.state.backOffice.service = "order";
                  store.state.fetchOrderListBack.order_status_id = 0;
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                } else {
                  next("/404");
                }
              },
            },
            {
              path: "/weserve_admin_login/orderwesmart/:province/orderlist/",
              component: () => import(`@/pages/back-office/OrderWesmart.vue`),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  "order_wesmart" in store.state.permission &&
                  Object.keys(store.state.permission.order_wesmart).length > 0
                ) {
                  store.state.backOffice.service = "order";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                } else {
                  next("/404");
                }
              },
              children: [
                {
                  path: "ordermade",
                  name: "orderwesmartordermade",
                  component: () =>
                    import(`@/pages/back-office/OrderWesmart/OrderMade.vue`),
                  props: true,
                },
                {
                  path: "onprocess",
                  name: "orderwesmartonprocess",
                  component: () =>
                    import(`@/pages/back-office/OrderWesmart/OnProcess.vue`),
                  props: true,
                },
                {
                  path: "completed",
                  name: "orderwesmartcompleted",
                  component: () =>
                    import(`@/pages/back-office/OrderWesmart/Completed.vue`),
                  props: true,
                },
                {
                  path: "cancel",
                  name: "orderwesmartcancel",
                  component: () =>
                    import(`@/pages/back-office/OrderWesmart/Cancelled.vue`),
                  props: true,
                },
                {
                  path: "pending",
                  name: "orderwesmartcancel",
                  component: () =>
                    import(`@/pages/back-office/OrderWesmart/PendingOrder.vue`),
                  props: true,
                },
                {
                  path: ":id",
                  name: "orderwesmartdetail",
                  component: () =>
                    import(`@/pages/back-office/OrderWesmart/OrderDetail.vue`),
                  props: true,
                },
              ],
            },
            {
              path:
                "/weserve_admin_login/control/:province/report/order_report_food",
              name: "reportFood",
              component: loadDashboardReportBackOffice("FoodReceipt"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.report.order_receipt ||
                  !store.state.permission.report.order_receipt
                    .food_delivery_receipt
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "report";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/report/order_report_free",
              name: "reportFree",
              component: loadDashboardReportBackOffice("FreeReceipt"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.report.order_receipt ||
                  !store.state.permission.report.order_receipt
                    .free_delivery_receipt
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "report";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/report/order_report_messenger",
              name: "reportMessenger",
              component: loadDashboardReportBackOffice("MessengerReceipt"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.report.order_receipt ||
                  !store.state.permission.report.order_receipt.messenger_receipt
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "report";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/report/main_dashboard",
              name: "main_dashboard",
              component: loadDashboardReportBackOffice("MainDashboard"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (Object.keys(store.state.permission.report).length == 0) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "report";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/report/store_report",
              name: "storeReport",
              component: loadDashboardReportBackOffice("StoreReport"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.report.free_food ||
                  !store.state.permission.report.free_food.store_report
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "report";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/report/store_payment",
              name: "storePayment",
              component: loadDashboardReportBackOffice("StorePayment"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.report.free_food ||
                  !store.state.permission.report.free_food.store_payment
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "report";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/report/store_payment_order/:ordertype/:storeid/:order_status/:datetime_start/:datetime_end",
              name: "storePaymentOrder",
              component: loadDashboardReportBackOffice("StorePaymentOrder"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.report.free_food ||
                  !store.state.permission.report.free_food.store_payment
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "report";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/report/sale_messenger_report",
              name: "SaleMessengerReport",
              component: loadDashboardReportBackOffice("SaleMessengerReport"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.report.messenger ||
                  !store.state.permission.report.messenger.sale_messenger
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "report";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/report/extra_credit_zone_report",
              name: "ExtraCreditZoneReport",
              component: loadDashboardReportBackOffice("ExtraCreditZoneReport"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.report.rider ||
                  !store.state.permission.report.rider.extra_credit_report
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "report";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/report/promotion_report",
              name: "PromotionReport",
              component: loadDashboardReportBackOffice("PromotionReport"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.report.summary ||
                  !store.state.permission.report.summary.promotion_report
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "report";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/report/customer_report",
              name: "CustomerReport",
              component: loadDashboardReportBackOffice("CustomerReport"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.report.summary ||
                  !store.state.permission.report.summary.customer_report
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "report";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/report/detail_customer_report/:customerid/:customername/:districtid/:orderstart/:orderend",
              name: "DetailCustomerReport",
              component: loadDashboardReportBackOffice("DetailCustomerReport"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.report.summary ||
                  !store.state.permission.report.summary.customer_report
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "report";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/report/order_report",
              name: "order_report",
              component: loadDashboardReportBackOffice("OrderReport"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.report.summary ||
                  !store.state.permission.report.summary.order_report
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "report";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/report/hotel-service",
              name: "hotel_service",
              redirect:
                "/weserve_admin_login/control/:province/report/hotel-service/order-report",
              component: () => import(
                "@/layouts/default.vue"
              ),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.report.hotel_service
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "report";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
              children: [
                {
                  path:
                    "order-report",
                  name: "hotel_order_report",
                  component: () => import('@/pages/back-office/Report/Dashboard/hotel-service/HotelOrderReport.vue'),
                  props: true,
                  beforeEnter: (to, from, next) => {
                    if (
                      !store.state.permission.report.hotel_service ||
                      !store.state.permission.report.hotel_service.hotel_order_report
                    ) {
                      next("/404");
                    } else {
                      store.state.backOffice.service = "report";
                      store.state.backOffice.province =
                        router.history.pending.params.province;
                      next();
                    }
                  }
                },
              ]
            },
            {
              path:
                "/weserve_admin_login/control/:province/report/order_report/order_detail/:orderid/food",
              name: "OrderDetailFood",
              component: loadDashboardReportBackOffice("OrderDetailFood"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.report.summary ||
                  !store.state.permission.report.summary.order_report
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "report";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/report/order_report/order_detail/:orderid/messenger",
              name: "OrderDetailMessenger",
              component: loadDashboardReportBackOffice("OrderDetailMessenger"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.report.summary ||
                  !store.state.permission.report.summary.order_report
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "report";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/report/rider_report",
              name: "rider_report",
              component: loadDashboardReportBackOffice("RiderReport"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.report.rider ||
                  !store.state.permission.report.rider.rider_user_report
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "report";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/rider/riderdashboard",
              name: "riderdashboard",
              component: loadRiderBackOffice("RiderDashboard"),
              props: true,
              beforeEnter: (to, from, next) => {
                store.state.backOffice.service = "rider";
                store.state.backOffice.province =
                  router.history.pending.params.province;
                next();
              },
            },
            {
              path: "/weserve_admin_login/control/:province/rider/riderinhouse",
              name: "riders",
              component: loadRiderBackOffice("RiderInHouse"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.rider.rider_list ||
                  !store.state.permission.rider.rider_list.rider_user
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "rider";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path: "/weserve_admin_login/control/:province/rider/rider-delete",
              name: "RiderDeleted",
              component: loadRiderBackOffice("RiderDeleted"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.rider.rider_list ||
                  !store.state.permission.rider.rider_list.rider_user
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "rider";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path: "/weserve_admin_login/control/:province/rider/riderapprove",
              name: "riderapprove",
              component: loadRiderBackOffice("RiderPending"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.rider.rider_list ||
                  !store.state.permission.rider.rider_list.rider_approve
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "rider";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path: "/weserve_admin_login/control/:province/rider/rider/:id",
              name: "riderdetail",
              component: loadRiderBackOffice("RiderDetail"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  Object.keys(store.state.permission.rider.rider_list).length ==
                  0
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "rider";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/rider/:isapprove/:id",
              name: "rideredit",
              component: loadRiderBackOffice("RiderEdit"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  Object.keys(store.state.permission.rider.rider_list).length ==
                  0
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "rider";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path: "/weserve_admin_login/control/:province/rider/head",
              name: "head",
              component: loadRiderBackOffice("Head"),
              props: true,
              beforeEnter: (to, from, next) => {
                store.state.backOffice.service = "rider";
                store.state.backOffice.province =
                  router.history.pending.params.province;
                next();
              },
            },
            {
              path: "/weserve_admin_login/control/:province/rider/hub",
              name: "hub",
              component: loadRiderBackOffice("Hub"),
              props: true,
              beforeEnter: (to, from, next) => {
                store.state.backOffice.service = "rider";
                store.state.backOffice.province =
                  router.history.pending.params.province;
                next();
              },
            },
            {
              path: "/weserve_admin_login/control/:province/rider/wallet",
              name: "wallet",
              component: loadRiderBackOffice("Wallet"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.rider.rider_money ||
                  !store.state.permission.rider.rider_money.rider_wallet
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "rider";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/rider/wallet/transaction/:rider_id",
              name: "transection",
              component: loadRiderBackOffice("Transaction"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.rider.rider_money ||
                  !store.state.permission.rider.rider_money.rider_wallet
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "rider";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path: "/weserve_admin_login/control/:province/rider/request_cash",
              component: () => import(
                "@/layouts/default.vue"
              ),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.rider.rider_money ||
                  !store.state.permission.rider.rider_money.rider_request
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "rider";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
              children: [
                {
                  path: "",
                  name: "requestcash",
                  component: loadRiderBackOffice("RequestCash"),
                },
                {
                  path: "log-table",
                  name: "log-requestcash",
                  component: loadRiderBackOffice("RequestCashLog"),
                },]
            },
            {
              path:
                "/weserve_admin_login/control/:province/rider/refill_credit",
              name: "refillcredit",
              component: loadRiderBackOffice("RefillCredit"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.rider.rider_money ||
                  !store.state.permission.rider.rider_money.rider_refill
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "rider";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/rider/withdraw_cash",
              name: "withdrawcash",
              component: loadRiderBackOffice("WithdrawCash"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.rider.rider_money ||
                  !store.state.permission.rider.rider_money.rider_withdraw
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "rider";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/rider/deposit_commission",
              name: "deposit_commission",
              component: loadRiderBackOffice("DepositCommission"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.rider.rider_commission ||
                  !store.state.permission.rider.rider_commission
                    .rider_deposit_commission
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "rider";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/rider/withdraw_commission",
              name: "withdraw_commission",
              component: loadRiderBackOffice("WithdrawCommission"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.rider.rider_commission ||
                  !store.state.permission.rider.rider_commission
                    .rider_withdraw_commission
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "rider";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path: "/weserve_admin_login/control/:province/rider/penalty",
              name: "penalty",
              component: loadRiderBackOffice("Penalty"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.rider.rider_commission ||
                  !store.state.permission.rider.rider_commission.rider_penalty
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "rider";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/rider/setting_general",
              name: "general",
              component: loadRiderBackOffice("General"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.rider.rider_setting) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "rider";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path: "/weserve_admin_login/control/:province/rider/setting_bank",
              name: "bank",
              component: loadRiderBackOffice("Bank"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (
                  !store.state.permission.rider.rider_setting ||
                  !store.state.permission.rider.rider_setting.rider_bank
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "rider";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/rider/setting_advertise",
              name: "advertise",
              component: loadRiderBackOffice("Advertise"),
              props: true,
              beforeEnter: (to, from, next) => {
                store.state.backOffice.service = "rider";
                store.state.backOffice.province =
                  router.history.pending.params.province;
                next();
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/messenger/addontime",
              name: "addontime",
              component: loadMessengerBack("AddOnTime/index"),
              props: true,
              beforeEnter: (to, from, next) => {
                store.state.backOffice.service = "messenger";
                store.state.backOffice.province =
                  router.history.pending.params.province;
                next();
              },
            },
            {
              path: "/weserve_admin_login/control/:province/messenger/addon",
              name: "addon",
              component: loadMessengerBack("AddOn/index"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.messenger.addon) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "messenger";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/messenger/vehicletype",
              name: "vehicletype",
              component: loadMessengerBack("VehicleType/index"),
              props: true,
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.messenger.vehicle) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "messenger";
                  store.state.backOffice.province =
                    router.history.pending.params.province;
                  next();
                }
              },
            },
            {
              path:
                "/weserve_admin_login/control/:province/messenger/extratime",
              name: "extratime",
              component: loadMessengerBack("ExtraTime/index"),
              props: true,
              beforeEnter: (to, from, next) => {
                store.state.backOffice.service = "messenger";
                store.state.backOffice.province =
                  router.history.pending.params.province;
                next();
              },
            },
            {
              path: "/weserve_admin_login/weserve-ads",
              name: "weserveADS",
              component: () => import("@/pages/back-office/WeserveADS.vue"),
              beforeEnter: (to, from, next) => {
                if ("weserve_ads" in store.state.permission.main_menu) {
                  store.state.backOffice.service = "weserve_ads";
                  next();
                } else {
                  next("/404");
                }
              },
            },
            {
              path: "/weserve_admin_login/:province/business",
              name: "businesslist",
              component: () => import("@/pages/back-office/Business/index"),
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.main_menu.dine_in_management) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "maindinein";
                  if (router.history.pending.params.province != "-") {
                    store.state.backOffice.province =
                      router.history.pending.params.province;
                  }
                  next();
                }
              },
              children: [
                {
                  path: "table",
                  name: "businesstable",
                  component: () =>
                    import("@/pages/back-office/Business/businessList"),
                },
                {
                  path: "table-log",
                  name: "tablelog",
                  component: () =>
                    import("@/pages/back-office/Business/business-log"),
                },
                {
                  path: "business-client",
                  name: "businessclient",
                  component: () =>
                    import("@/pages/back-office/Business/business-client"),
                },
                {
                  path: "monitor-invoice",
                  name: "minitorinvoice",
                  component: () =>
                    import("@/pages/back-office/Business/monitor"),
                },
                {
                  path: "business-client/:business_id/:firstname/:lastname",
                  name: "businessclient_id",
                  component: () =>
                    import("@/pages/back-office/Business/detail/businessClient_detail"),
                },
                {
                  path: "detail/:business_id",
                  name: "businessid",
                  component: () =>
                    import("@/pages/back-office/Business/detail/businessDetail.vue"),
                },
              ],
            },
            {
              path: "/weserve_admin_login/:province/hotel-services",
              name: "hotelMainMenu",
              component: () => import("@/pages/back-office/HotelServices/index.vue"),
              beforeEnter: (to, from, next) => {
                if (!store.state.permission.main_menu.hotel_service) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "mainhotel";
                  if (router.history.pending.params.province != "-") {
                    store.state.backOffice.province =
                      router.history.pending.params.province;
                  }
                  next();
                }
              },
              children: [
                {
                  path: "hotel-list",
                  name: "hotelList",
                  component: () =>
                    import("@/pages/back-office/HotelServices/HotelList/index.vue"),
                  beforeEnter(to, from, next) {
                    if (
                      !store.state.permission.main_menu.hotel_service ||
                      !store.state.permission.main_menu.hotel_service
                        .hotel_manage
                    ) {
                      next("/404");
                    } else {
                      store.state.backOffice.service = "mainhotel";
                      if (router.history.pending.params.province != "-") {
                        store.state.backOffice.province =
                          router.history.pending.params.province;
                      }
                      next();
                    }
                  }
                },
              ]
            },
            {
              path: "/weserve_admin_login/tracking/:province/rider-tracker",
              name: "riderTracker",
              component: loadBackOffice("RiderTracker"),
              props: true,
              beforeEnter(to, from, next) {
                if (
                  !store.state.permission.main_menu.tracking_rider
                ) {
                  next("/404");
                } else {
                  store.state.backOffice.service = "tracking";
                  if (router.history.pending.params.province != "-") {
                    store.state.backOffice.province =
                      router.history.pending.params.province;
                  }
                  next();
                }
              }
            },
          ],
        },
      ],
    },

    {
      path: "/404",
      component: NotFound,
    },
    {
      path: "*",
      redirect: "/404",
    },
  ],
});
export default router;
